import { render } from "./CommunExp.vue?vue&type=template&id=bcc9c004"
import script from "./CommunExp.vue?vue&type=script&lang=js"
export * from "./CommunExp.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__